export interface NewsItem {
  newsId: string;
  title: string;
  summary: string;
  steps?: readonly { title: string; description: string }[];
  tip?: string;
}

// Investigator announcements ship with the app and display in array order.
// IDs must be unique and stable: copy edits keep the existing ID so dismissed
// items stay dismissed. Use a new versioned ID for an announcement users should
// see again (for example, investigator-welcome-v2).
export const investigatorNews: readonly NewsItem[] = [
  {
    newsId: "investigator-welcome-v1",
    title: "Investigator quick start",
    summary:
      "Bring your evidence together, review your case, and find answers in one place.",
    steps: [
      {
        title: "Start an incident",
        description:
          "Go to Incidents and select New Incident. Enter a title and the details you know.",
      },
      {
        title: "Add and review evidence",
        description:
          "Upload files or choose Add from file library, then select Create Incident. Once processing finishes, check Narrative and Timeline against your evidence.",
      },
      {
        title: "Ask about the evidence",
        description:
          "Use AI Assistant on the right to ask questions about the incident.",
      },
    ],
    tip: "Each page offers a spotlight tour on your first visit. Select Page tutorial in the sidebar to replay it.",
  },
];
